import { render, staticRenderFns } from "./Colaboradores.vue?vue&type=template&id=27a298bf"
import script from "./Colaboradores.vue?vue&type=script&lang=ts"
export * from "./Colaboradores.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports